import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var Contact =
/*#__PURE__*/
function (_BaseData) {
  _inherits(Contact, _BaseData);

  function Contact() {
    var _this;

    _classCallCheck(this, Contact);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Contact).call(this, "Contact"));
    _this.Types = {
      GeneralPartner: 1,
      LimitedPartner: 2,
      RegionalContact: 3,
      LeasingAgent: 4,
      ComplianceContact: 5,
      PrimaryContact: 6,
      OccupancyContact: 7,
      FinancialContact: 8
    };
    return _this;
  }

  _createClass(Contact, [{
    key: "GetContactTypes",
    value: function GetContactTypes() {
      return axios.get("/api/Contact/GetContactTypes");
    }
  }, {
    key: "CreateContactTypeLink",
    value: function CreateContactTypeLink(contactId, typeId) {
      return axios.post("/api/Contact/CreateContactTypeLink", {
        ContactId: contactId,
        TypeId: typeId
      });
    }
  }, {
    key: "DeleteContactTypeLink",
    value: function DeleteContactTypeLink(contactId, typeId) {
      return axios.delete("/api/Contact/DeleteContactTypeLink", {
        params: {
          ContactId: contactId,
          TypeId: typeId
        }
      });
    }
  }, {
    key: "DeleteContact",
    value: function DeleteContact(contactId, reviewComments) {
      return axios.delete("/api/Contact/DeleteContact", {
        params: {
          contactId: contactId,
          reviewComments: reviewComments
        }
      });
    }
  }, {
    key: "UpdateContact",
    value: function UpdateContact(contact) {
      return axios.patch("/api/Contact/UpdateContact", contact);
    }
  }, {
    key: "GetContactsByProjectId",
    value: function GetContactsByProjectId(projectId) {
      return axios.get("/api/Contact/GetContactsByProjectId/".concat(projectId));
    }
  }, {
    key: "GetContactsByProjectIdAndTinRequirement",
    value: function GetContactsByProjectIdAndTinRequirement(projectId, tinRequired) {
      return axios.get("/api/Contact/GetContactsByProjectId/".concat(projectId, "/").concat(tinRequired));
    }
  }, {
    key: "GetContactsByPropertyAndType",
    value: function GetContactsByPropertyAndType(projectId, contactType) {
      return axios.get("/api/Contact/GetContactsByPropertyAndType/".concat(projectId, "/").concat(contactType));
    }
  }, {
    key: "GetContactsWithChangeRequests",
    value: function GetContactsWithChangeRequests() {
      return axios.get("/api/Contact/GetContactsWithChangeRequests");
    }
  }, {
    key: "GetContactByContactId",
    value: function GetContactByContactId(contactId) {
      return axios.get("/api/Contact/GetContactByContactId/".concat(contactId));
    }
  }, {
    key: "RemoveAllContactTypeLink",
    value: function RemoveAllContactTypeLink(contactId) {
      return axios.get("/api/Contact/RemoveAllContactTypeLink/".concat(contactId));
    }
  }, {
    key: "GetMcPrimaryContact",
    value: function GetMcPrimaryContact(ManagementCompanyId) {
      return axios.get("/api/Contact/GetMcPrimaryContact/".concat(ManagementCompanyId));
    }
  }]);

  return Contact;
}(BaseData);

export default new Contact();